import { render, staticRenderFns } from "./FbDate.vue?vue&type=template&id=57098016"
import script from "./FbDate.vue?vue&type=script&lang=js"
export * from "./FbDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports